import styled, { css } from 'styled-components';

export const RowWrapper = styled.div`
  width: 100%;
  min-height: 50px;
`;

export const TopicRowWrapper = styled(RowWrapper)`
  border-top: ${({ theme }) => `1px solid ${theme.black.a1}`};
  height: 50px;
`;

export const TitleContainer = styled.div<{ $border?: boolean }>(
  ({ $border, theme }) => css`
    margin-left: 345px;
    display: flex;
    overflow: scroll;
    /* IE 10+ */
    -ms-overflow-style: none;
    /* Firefox */
    scrollbar-width: none;
    /* Safari and Chrome */
    &::-webkit-scrollbar {
      display: none;
    }

    border-top: ${$border ? `1px solid ${theme.black.a1}` : 'none'};
    border-left: 1px solid ${theme.black.a1};
  `,
);

export const BoxPadding = styled.div<{ $showFade: boolean }>`
  display: flex;
  height: 100%;
  width: 100%;
  align-items: start;
  position: relative;
  overflow: hidden;
  &::after {
    content: '';
    visibility: ${({ $showFade }) => ($showFade ? 'visible' : 'hidden')};
    width: 100px;
    height: 22px;
    position: absolute;
    right: 0;
    bottom: 0;
    background: linear-gradient(90deg, rgba(237, 237, 237, 0) 0%, rgba(237, 237, 237, 1) 78%);
  }
  > div {
    line-height: 20px;
    padding: 6px 10px;
    width: 100%;
    min-height: 100%;
    display: flex;
    align-items: center;
  }
`;

export const TableTitleBox = styled.div`
  height: 70px;
  border-right: 1px solid ${({ theme }) => theme.black.a1};
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  width: 221px;
  opacity: 1;
  cursor: pointer;
  position: relative;
  &:hover {
    min-height: 70px;
    height: auto;
    z-index: 100;
    background-color: ${({ theme }) => theme.black.a0};
    & > ${BoxPadding} {
      &::after {
        display: none;
      }
    }
  }
`;
